import { AllCompaniesThemeModeConfig } from './types';

const dark: AllCompaniesThemeModeConfig = {
  allCompanies: {},
};

export default dark;
